<template>
  <div class="fl-cabinet-layout" :class="classList">
    <div class="fl-cabinet-layout__navbar">
      <fl-header />
    </div>
    <div class="fl-cabinet-layout__page">
      <aside class="fl-cabinet-layout__sidebar">
        <fl-navigation
          :list="navigationList"
        />
      </aside>
      <div
        class="fl-cabinet-layout__sidebar-overlay"
        @click="closeMobileMenu"
      />
      <div class="fl-cabinet-layout__content">
        <section class="fl-cabinet-layout__body">
          <slot name="router"></slot>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
import FlHeader from "@/layouts/FlHeader/FlHeader.vue";
import FlNavigation from "@/layouts/FlNavigation/FlNavigation.vue";
import {useUserStore} from "@/modules/User/store/user";
import {useLayoutStore} from "@/store/layout";
import {useWindowStore} from "@iflat-ui/stores/window";
import {createJivoChat} from "@/lib/jivo";

export default {
  components: {FlNavigation, FlHeader},
  data() {
    return {
      userStore: useUserStore(),
      layoutStore: useLayoutStore(),
      windowStore: useWindowStore(),
      navigationList: [
        {
          title: 'Приемки',
          path: {name: this.$routes.INSPECTIONS},
          name: 'inspections',
          icon: 'uiHouse'
        },
        {
          title: 'Календарь',
          path: {name: this.$routes.TASKS},
          name: 'checkList',
          icon: 'calendar'
        },
        {
          title: 'Настройки',
          path: {name: this.$routes.SETTINGS},
          name: 'settings',
          icon: 'uiSettings'
        },
      ]
    }
  },
  computed: {
    classList() {
      return {
        '_is-open-menu': this.layoutStore.isOpenMobileMenu
      }
    },
  },

  mounted() {
    createJivoChat()
  },


  watch: {
    'windowStore.isDesktop' (isDesktop) {
      if(!isDesktop) return
      this.closeMobileMenu()
    }
  },
  methods: {
    closeMobileMenu() {
      this.layoutStore.closeMobileMenu()
    }
  }
}
</script>

<style lang="scss" scoped>
.fl-cabinet-layout {
  $parent: &;
  @include grid;
  align-content: start;
  grid-template-rows: auto 1fr;

  &__page {
    position: relative;
    display: grid;
    grid-template-columns: 200px $grid-auto-fr;
  }

  &__sidebar {
    @include transition-list([transform, opacity, visibility]);
    padding: 27px 12px;
    background-color: $light-02;
  }

  &__sidebar-overlay {
    @include transition-list([opacity, visibility]);
    visibility: hidden;
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    overflow: hidden;
    z-index: 1000;
    background: rgba(0, 0, 0, 0.3);
    opacity: 0;
  }

  &__content {
    @include flex-column;
    position: relative;
  }

  &__header {
    @include flex-space-between;
    flex-wrap: wrap;
    padding: 30px 30px 0;
  }

  &__body {
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    padding: 30px 30px 60px;
  }

  @include media-max-lg {
    &__page {
      grid-template-columns: $grid-auto-fr;
    }

    &__body {
      padding: 20px;
    }

    &__sidebar {
      @include pretty-scrollbar-s;
      position: fixed;
      top: 0;
      height: 100%;
      overflow-y: auto;
      z-index: 1111;

      visibility: hidden;
      opacity: 0;
      transform: translateX(-100%)
    }

    &._is-open-menu {
      #{$parent}__sidebar-overlay {
        visibility: visible;
        opacity: 1;
      }
      #{$parent}__sidebar {
        visibility: visible;
        opacity: 1;
        transform: translateX(0)
      }
    }
  }

  @include media-max-wide-sm {
    &__body {
      padding: 15px;
    }

    &__header {
      padding: 15px 15px 0;
    }
  }
}
</style>
